import * as SessionManagementChannelDefinitions from '@tableau/microview-communication-service/lib/src/channelDefinitions/SessionManagementChannelDefinitions';
import { ExtractEncryptionMode } from '../models/SitePropertyTypes';

export class SessionManagementService {
  public static instance = new SessionManagementService();

  public sessionSiteUrlName(): string {
    const channel = new SessionManagementChannelDefinitions.SessionSiteUrlNameChannel();
    return channel.call().data?.seassionSiteUrlName || '';
  }

  public isExtractEncryptionEnabledOmniSwitch(): boolean {
    const channel = new SessionManagementChannelDefinitions.ExtractEncryptionEnabledOmniSwitchChannel();
    return channel.call().data?.extractEncryptionEnabled || false;
  }

  public getExtractEncryptionModeForSite(): ExtractEncryptionMode {
    const channel = new SessionManagementChannelDefinitions.ExtractEncryptionModeForSiteChannel();
    return channel.call().data?.extractEncryptionMode || ExtractEncryptionMode.DISABLED;
  }

  public catalogingOnSiteEnabled(): boolean {
    const channel = new SessionManagementChannelDefinitions.CatalogOnsiteEnabledChannel();
    return channel.call().data?.catalogOnsiteEnabled || false;
  }

  public collectionsEnabled(): boolean {
    const channel = new SessionManagementChannelDefinitions.CollectionsEnabledChannel();
    return channel.call().data?.collectionsEnabled || false;
  }

  public metricsOnSiteEnabled(): boolean {
    const channel = new SessionManagementChannelDefinitions.MetricsOnSiteEnabledChannel();
    return channel.call().data?.metricsOnSiteEnabled || false;
  }

  public sessionUserId(): string | undefined {
    const channel = new SessionManagementChannelDefinitions.SessionUserIDChannel();
    return channel.call().data?.sessionUserId;
  }

  public isSessionServerAdmin(): boolean {
    const channel = new SessionManagementChannelDefinitions.IsSessionServerAdminChannel();
    return channel.call().data?.isSessionServerAdmin || false;
  }

  public isSessionSiteAdmin(): boolean {
    const channel = new SessionManagementChannelDefinitions.IsSessionSiteAdminChannel();
    return channel.call().data?.isSessionSiteAdmin || false;
  }

  public isLimitedUserVisibilityChannel(): boolean {
    const channel = new SessionManagementChannelDefinitions.IsLimitedUserVisibilityChannel();
    return channel.call().data?.isUserLimitedVisibility || false;
  }
}
